module.exports = __webpack_public_path__ + "static/media/platicasPrematiminialesactual.954787f3.jpeg";